module.exports = __webpack_public_path__ + "img/证书耗材.3a6f7be5.png";